export const title = 'How to Teach a Group to Sing in Harmony';

export function GroupHarmonyTutorial() {
  return <div>{title}</div>;
}
